'use client'

import { useEffect } from 'react'

const COOKIE_NAME = 'accessToken'
const COOKIE_TTL_SECONDS = 60 * 60 * 24 * 30

const parseStoredToken = (): null | string => {
  const storedToken = window.localStorage.getItem(COOKIE_NAME)

  if (!storedToken || storedToken === 'undefined' || storedToken === 'null') {
    return null
  }

  try {
    return JSON.parse(storedToken) as string
  } catch {
    return null
  }
}

export function AuthCookieSync() {
  useEffect(() => {
    const accessToken = parseStoredToken()

    if (!accessToken) {
      document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`

      return
    }

    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(accessToken)}; path=/; max-age=${COOKIE_TTL_SECONDS}; SameSite=Lax`
  }, [])

  return null
}
